import { Directive, HostBinding } from '@angular/core';

import { A11yRole } from '../interfaces/a11y.interfaces';

@Directive({
  selector: '[khA11yMenu]'
})
export class A11yMenuDirective implements A11yRole {
  @HostBinding('attr.role') public readonly role = 'menu';
}
